import React, { useState, useCallback, useEffect } from "react";
import { useMediaQueries } from "../../../../../../utils/mediaQueries";
import { Icon } from "../../../../../../elements";
import { Avatar } from "@mui/material";
import SearchInput from "./SearchInput";
import {
  ListWrapper,
  ListItems,
  ListItemGroup,
  ItemWrapper,
  ItemContent,
  AvatarWrapper,
  Overlay,
  CenteredModal,
} from "../UserSelector.styled";

const UserList = ({ isVisible, items, onSelect, onClose, hideSearchInput = false, top }) => {
  const { isMobile, isTablet } = useMediaQueries();
  const [searchValue, setSearchValue] = useState("");
  const [displayedItems, setDisplayedItems] = useState(items);

  const onHandleSearch = useCallback((inputValue) => {
    setSearchValue(inputValue);
  }, []);

  const onHandleSelectItem = useCallback(
    (id) => {
      setSearchValue("");
      onSelect && onSelect(id);
    },
    [onSelect],
  );

  useEffect(() => {
    const filteredItems = !searchValue || searchValue.trim() === ""
      ? items
      : items.filter(item => {
        const fullName = item.name.toLowerCase();
        return fullName.includes(searchValue.toLowerCase().trim());
      });

    setDisplayedItems(filteredItems);
  }, [searchValue, items]);


  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const content = (
    <>
      {!hideSearchInput && (
        <SearchInput
          defaultValue={searchValue}
          onChange={onHandleSearch}
        />
      )}
      <ListItems>
        <ListItemGroup>
          {displayedItems.length === 0 && <p>No users found</p>}
          {displayedItems.map((item, i) => (
            <ItemWrapper
              key={i}
              onClick={() => onHandleSelectItem(item.value)}
              isTablet={isTablet}
              data-testid={`user-item-${item.value}`}
              role="option"
              aria-selected={false}
              tabIndex={0}
            >
              <AvatarWrapper>
                {item.photo_url ?
                  <Avatar src={item.photo_url} alt="User" /> :
                  <Icon name="carbonUserAvatarFilled" width="24px" height="24px" />
                }
              </AvatarWrapper>
              <ItemContent isMobile={isMobile} isTablet={isTablet}>
                {item.name}
              </ItemContent>
            </ItemWrapper>
          ))}
        </ListItemGroup>
      </ListItems>
    </>
  );

  if (isMobile) {
    return (
      isVisible && (
        <Overlay onClick={handleOverlayClick}>
          <CenteredModal>
            {content}
          </CenteredModal>
        </Overlay>
      )
    );
  }

  return <ListWrapper isVisible={isVisible} top={top}>{content}</ListWrapper>;
};

export default UserList;
